<template>
    <v-container v-if="afterMounted == true && current_role=='employee'">
        <v-row>
            <v-col>
                <h1>Professional Information</h1>
                <p>Please ensure the information below is accurate and up to date. Your preferred name and pronoun will be displayed on the Adelphi website's public directory, and all other information will be kept confidential. <strong>If you have any questions or edits, please contact <a class="bold-link" href="https://hr.adelphi.edu/contact/" target="_blank">Human Resources.</a></strong></p>
            </v-col>
        </v-row>
        <div>
        <v-row>
            <v-col>
            <h2>General</h2>

            <v-row>
            <v-col cols="12" sm="3">
                <span class="label" aria-labelledby="ID">Adelphi ID</span>
            </v-col>
            <v-col cols="12" sm="9">
                <span id="ID" class="black-text">{{ this.professional_data.AdelphiID }}</span>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="3">
                <span class="label" aria-labelledby="OfficePhone">Office Phone</span>
            </v-col>
            <v-col cols="12" sm="9">
                <span id="OfficePhone" class="black-text">{{ this.professional_data.OfficePhone }}</span>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="3">
                <span class="label" aria-labelledby="Email">Email</span>
            </v-col>
            <v-col cols="12" sm="9">
                <span id="Email" class="black-text">{{ this.professional_data.AUEmail }}</span>
            </v-col>
        </v-row>
        <h2>Position</h2>
            <h3>Primary Role</h3>

            <v-row>
                <v-col cols="12" sm="3">
                <span class="label" aria-labelledby="MainPosition">Primary Title</span>
                </v-col>
                <v-col cols="12" sm="9">
                    <span id="MainPosition" class="black-text">{{ this.professional_data.PrimaryTitle }}</span>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" sm="3">
                <span class="label" aria-labelledby="salary">Salary</span>
                </v-col>
                <v-col cols="12" sm="9">
                    <span id="salary" class="black-text">${{ salary }}</span>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" sm="3">
                <span class="label" aria-labelledby="MainDepartment">Primary Department</span>
                </v-col>
                <v-col cols="12" sm="9">
                    <span id="MainDepartment" class="black-text">{{ this.professional_data.PrimaryDepartment }}</span>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" sm="3">
                    <v-label aria-hidden="true">Primary Sub-department <span class="label-not-strong">(if applicable)</span></v-label>
                </v-col>
                <v-col cols="12" sm="9">
                    <v-select v-model="selected_primary_subdept" aria-label="Primary Subdepartment (if applicable)" clearable outlined :items="primary_subdept" item-value="key" item-text="value" :value="this.professional_data.PrimarySubDepartment"></v-select>
                     <p class="instruction">If you do not see your sub-department within these options, please contact the <a class="bold-link" href="mailto:helpdesk@adelphi.edu" title="helpdesk@adelphi.edu">Help Desk.</a></p>
                
                </v-col>
            </v-row> 
             
            <div v-if="this.professional_data.SecondaryTitle != null && this.professional_data.SecondaryDepartment != null">
                <h3>Secondary Role</h3>
                <v-row>
                    <v-col cols="12" sm="3">
                    <span class="label" aria-labelledby="SecondaryPosition">Secondary Title</span>
                    </v-col>
                    <v-col cols="12" sm="9">
                        <span id="SecondaryPosition" class="black-text">{{ this.professional_data.SecondaryTitle }}</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="3">
                    <span class="label" aria-labelledby="SecondaryDepartment">Secondary Department</span>
                    </v-col>
                    <v-col cols="12" sm="9">
                        <span id="SecondaryDepartment" class="black-text">{{ this.professional_data.SecondaryDepartment }}</span>
                    </v-col>
                </v-row>

            

                <v-row>
                    <v-col cols="12" sm="3">
                        <v-label>Secondary Sub-department <span class="label-not-strong">(if applicable)</span></v-label>
                    </v-col>
                    <v-col cols="12" sm="9">
                        <v-select v-model="selected_secondary_subdept" outlined aria-label="Secondary Subdepartment (if applicable)" clearable :items="secondary_subdept" :value="this.professional_data.SecondarySubDepartment"></v-select>
                        <p class="instruction">If you do not see your sub-department within these options, please contact the <a class="bold-link" href="mailto:webteam@adelphi.edu" title="webteam@adelphi.edu">Web Team.</a></p>
                
                    </v-col>
                </v-row>
            </div>
            <h2>Office Location</h2>
                <v-row>
                    <v-col cols="12" sm="3">
                        <v-label aria-hidden="true">Room Number <span class="label-not-strong">(i.e. 203b)</span></v-label>
                    </v-col>
                    <v-col cols="12" sm="9">
                        <v-text-field v-model="room" outlined aria-label="Room" :value="this.professional_data.Room" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="3">
                        <v-label aria-hidden="true">Suite/Level <span class="label-not-strong">(if applicable)</span></v-label>
                    </v-col>
                    <v-col cols="12" sm="9">
                        <v-select v-model="selected_suite_level" outlined aria-label="Suite/Level (if applicable)" clearable :items="suite_level" item-value="PK" item-text="Description" :value="this.professional_data.SuiteLevel" />
                    </v-col>
                    
                </v-row>
                <v-row>
                    <v-col cols="12" sm="3">
                        <v-label aria-hidden="true">Building</v-label>
                    </v-col>
                    <v-col cols="12" sm="9">
                        <v-select v-model="selected_building" outlined aria-label="Building" clearable :items="buildings" item-value="PK" item-text="Description" :value="this.professional_data.Building" />
                    </v-col>
                </v-row>
            </v-col>
            </v-row>
            <h2>Credentials</h2>
            <p>Your degree(s), certifications, and licenses will appear after your name on the Adelphi website's public directory. If you do not see your credentials included, please email the <a href="mailto:digital@adelphi.edu" class="bold-link">Digital Team</a>.</p>
            <v-row>
                <v-col cols="12" md="3">
                    <v-label aria-hidden="true">Highest Degree Earned</v-label>
                </v-col>
                <v-col cols="12" md="9">
                    <v-autocomplete v-model="selected_degrees" aria-label="Highest Degree Earned" chips deletable-chips multiple outlined clearable :items="degree" dense />
                    
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-label aria-hidden="true">Certifications &amp; Licenses</v-label>
                </v-col>
                <v-col cols="12" md="9">
                    <v-autocomplete v-model="selected_credentials" aria-label="Certifications and Licenses" chips deletable-chips multiple outlined clearable :items="credentials" dense />
                    
                </v-col>
            </v-row>
           
            <!-- <h3>About</h3>
            <v-row>
                <v-col cols="12" md="3">
                    <v-label aria-hidden="true">Professional Bio</v-label>
                </v-col>
                <v-col cols="12" md="9">
                    <v-textarea v-model="professional_bio" aria-label="Professional Biography" outlined counter auto-grow maxlength="450" />
                    <p class="instruction">This short blurb should not exceed 450 characters. This can include your research, highlight professional interests and/or speak to your industry expertise. </p>
                    
                </v-col>
                
            </v-row>
            <v-row>
                <v-col cols="12" md="3"></v-col>
                <v-col cols="12" md="9">
                    <p class="instruction">Please note your bio will be reviewed before updated to your profile on the website. This new component is still a work in progress so it may take some time before you see your additions reflected on the website. </p>
             
                </v-col>
            </v-row> -->
            
        
            <h2>Headshot</h2>
            <!-- <p>University Communications and Marketing offer professional headshots througout the year. To schedule a photo shoot, email UCOMM at <a class="bold-link" href="mailto:photos@adelphi.edu" title="UCOMM Photos">photos@adelphi.edu</a>.</p>
            <p>If you are unable to have a headshot taken by our photographer but would like to provide one for us to use on your directory listing and/or faculty profile, please submit below. Please note that any submissions will be reviewed for quality assurance.</p> -->
            <p>Upload a professional headshot to the University directory and/or your Faculty Profile.</p>
             <v-row>
                 <v-col><v-file-input accept="image/*" outlined prepend-icon="mdi-camera" v-model="headshot" label="Upload Photo" aria-label="Upload Photo"/>              
            <p class="instruction">High-resolution, uncropped images are preferred. Files must be a minimum of 500x500 pixels. Please note that all photos will be reviewed for quality assurance.</p>
                 </v-col>
            </v-row>
        
        <v-btn @click="this.saveAllChanges" color="#ffb500" :loading="loading" :disabled="loading" class="black--text v-btn v-btn--contained theme--light v-size--x-large">Submit Changes</v-btn>
        <v-snackbar v-model="data_saved">
            Your information has been saved.
            <v-btn @click="data_saved = false">Close</v-btn>
        </v-snackbar>
        </div>
    </v-container>
</template>

<script>
import axios from 'axios'
export default {
    //props: ['professional_data', 'primary_subdept', 'secondary_subdept', 'headshot', 'loader', 'loading'],
    data: () => ({
        data_saved: false,
        professional_data: null,
        primary_subdept: [],
        secondary_subdept: [],

        selected_primary_subdept: null,
        selected_secondary_subdept: null,
        room: null,
        selected_suite_level: null,
        selected_building: null,

        suite_level: [],
        buildings: [],
        afterMounted: false,

        salary: '' ,

        degree: [
            'AA',
            'AS',
            'BA',
            'BBA',
            'BFA',
            'BS',
            'BSW',
            'DCJ',
            'DHSc',
            'DMA',
            'EdM',
            'EdS',
            'MA',
            'MAPC',
            'MAT',
            'MArch',
            'MBA',
            'MDiv',
            'MEd',
            'MFA',
            'MHA',
            'MHR',
            'MIDS',
            'MLIS',
            'MLS',
            'MM',
            'MPA',
            'MPH',
            'MPhil',
            'MS',
            'MSC',
            'MSEd',
            'MSIE',
            'MSILR',
            'MSLIS',
            'MSN',
            'MSPH',
            'MSSW',
            'MSW',
            'MTS',
            'AuD',
            'ClinPsyD',
            'DA',
            'DBA',
            'DC',
            'DClinPsy',
            'DD',
            'DDS',
            'DHA',
            'DHL',
            'DMD',
            'DMFT',
            'DNP',
            'CARN',
            'CARN-AP',
            'DNS',
            'DO',
            'DrPH',
            'DSW',
            'DVM',
            'EdD',
            'JD',
            'MD',
            'PD',
            'PhD',
            'PharmD',
            'PsyaD',
            'PsyD',
            'ScD',
            'VMD',

        ],
        credentials: [
         'ABECSW',
         'ABPN',
         'ABPP',
         'ABT-NTC-CT',
         'ACSW',
         'AGNP-C',
         'AGPCNP',
         'ANP-BC',
         'APRN',
         'ARCO',
         'ASHA Fellow',
         'ATC',
         'BCBT',
         'BCD',
         'BCDT',
         'BCDV',
         'BCP',
         'CACA',
         'CADAC',
         'CAGS',
         'CAPM',
         'CAPP',
         'CARN',
         'CARN-AP',
         'CASAC',
         'CASAC-T',
         'CBCP',
         'CCADC',
         'CCC-A',
         'CCC-SLP',
         'CCP',
         'CEM',
         'CEN',
         'CGP',
         'CHES',
         'CISSP',
         'CMHC',
         'CNE',
         'CNM',
         'CPA',
         'CPHQ',
         'CPsych',
         'CQ',
         'CRADC',
         'CRC',
         'CRNA',
         'CSP',
         'CSW-C',
         'CSW-G',
         'DFAGPA',
         'DPNAP',
         'E-RYT',
         'FAAA',
         'FAAN',
         'FAANP',
         'FAGPA',
         'FAPA',
         'FM-CE',
         'FNP-BC',
         'FRCO',
         'IMH-DP',
         'IMH-E',
         'LAT',
         'LCAT',
         'LCMHC',
         'LCPC',
         'LCSW',
         'LCSW-R',
         'LGSW',
         'LICSW',
         'LLD',
         'LMFT',
         'LMHC',
         'LMSW',
         'LMSW-ACP',
         'LPC',
         'LPC-S',
         'LPCC',
         'LPN',
         'LSATP',
         'LSP',
         'LSW',
         'MAC',
         'MCHES',
         'NCC',
         'NP',
         'NP-C',
         'NYSED N-6',
         'NYSED Reading',
         'NYSED School Admin/Supervisor',
         'NYSED School District Admin',
         'NYSED Social Studies 7-12',
         'NYSED Special Education',
         'NYSED Visual Arts K-12',
         'Orthodontist',
         'PC',
         'PE',
         'PfMP',
         'PgMP',
         'PMHNP',
         'PMI-ACP',
         'PMI-PBA',
         'PMI-RMP',
         'PMI-SP',
         'PMP',
         'QDCS',
         'RN',
         'SHRM-CP',
         'SHRM-SCP',
         'TSSLD',
         'WHNP-BC',
         'YACEP'
        ],

        selected_degrees: [],
        selected_credentials: [],
        headshot: null,
        professional_bio: null,
        loader: null,
        loading: false,
        current_role: null,
    }),

    // mounted() {
    //     axios.get('./remote-apis/building-locations.php')
    //         .then(response => {
    //             this.buildings = response.data
    //             window.console.log(response.data)
    //         })
    //         .catch(error => {
    //             window.console.error(error)
    //         })
    // },

    // watch: {
    //   loader () {
    //     const l = this.loader
    //     this[l] = !this[l]

    //     setTimeout(() => (this[l] = false), 3000)

    //     this.loader = null
    //   },
    // },

    mounted() {
        /*
        // hide chatbot
        document.querySelectorAll('._admithub_embed-container').forEach(function(el) {
            el.style.display = 'none';
        });
        */
        axios.get('./remote-apis/user-api.php?cmd=cur_role')
            .then((response) => {
              this.current_role = response.data.cur_role;
              // logged in as student, redirect to student page
              if (this.current_role == "student") {
                window.location = "./remote-apis/auth-redirect.php?goto=personal-student";
                return;
              }
        })
            .catch((err) => {
              window.console.log(err)
        })

        axios.get('./remote-apis/user-api.php?cmd=professional')
            .then(response => {
                this.professional_data = response.data.ROOT.Directory_SS;
                //window.console.log(response.data.ROOT.Directory_SS);
                this.selected_primary_subdept = this.professional_data.PrimarySubDepartment;
                this.selected_secondary_subdept = this.professional_data.SecondarySubDepartment;
                this.room = this.professional_data.Room;
                this.selected_suite_level = this.professional_data.SuiteLevel;
                this.selected_building = this.professional_data.Building;
                
                if (Array.isArray(this.professional_data.HighestDegreeEarned_MV)) {
                    for (let i = 0; i < this.professional_data.HighestDegreeEarned_MV.length; i++) {
                        this.selected_degrees.push(this.professional_data.HighestDegreeEarned_MV[i].HighestDegreeEarned)
                    }
                }else {
                    this.selected_degrees.push(this.professional_data.HighestDegreeEarned_MV.HighestDegreeEarned)
                }
                
                if (Array.isArray(this.professional_data.CertificationsLicenses_MV)) {
                    for (let j = 0; j < this.professional_data.CertificationsLicenses_MV.length; j++) {
                        this.selected_credentials.push(this.professional_data.CertificationsLicenses_MV[j].CertificationsLicenses)
                        //window.console.log(this.professional_data.CertificationsLicenses_MV[j].CertificationsLicenses)
                    }
                }else {
                    this.selected_credentials.push(this.professional_data.CertificationsLicenses_MV.CertificationsLicenses)
                }
                this.professional_bio = this.professional_data.Professional_Bio
                
                this.afterMounted = true;
                //window.console.log('Degrees: '+this.selected_degrees)
            })
            .catch(error => {
                window.console.error(error);
            })
        axios.get('./remote-apis/user-api.php?cmd=psub')
            .then(response => {
                //let temp_array = response.data.ROOT.SUB_DEPARTMENTS
                //this.primary_subdept = response.data.ROOT.SUB_DEPARTMENTS;
                //window.console.log(response.data.ROOT.SUB_DEPARTMENTS);
                if (Array.isArray(response.data.ROOT.SUB_DEPARTMENTS) == false) {
                    this.primary_subdept.push({key: response.data.ROOT.SUB_DEPARTMENTS.PK, value: response.data.ROOT.SUB_DEPARTMENTS.DESC})
                }else {
                    for (let i = 0; i < response.data.ROOT.SUB_DEPARTMENTS.length; i++) {
                        this.primary_subdept.push({key: response.data.ROOT.SUB_DEPARTMENTS[i].PK, value: response.data.ROOT.SUB_DEPARTMENTS[i].DESC});
                    }
                }
            })

        axios.get('./remote-apis/user-api.php?cmd=ssub')
            .then(response => {
                //let temp_array = response.data.ROOT.SUB_DEPARTMENTS
                //this.primary_subdept = response.data.ROOT.SUB_DEPARTMENTS;
                //window.console.log(response.data.ROOT.SUB_DEPARTMENTS);
                if (response.data.ROOT != null) {
                    if (Array.isArray(response.data.ROOT.SUB_DEPARTMENTS) == false) {
                        this.secondary_subdept.push(response.data.ROOT.SUB_DEPARTMENTS.PK);
                    }else {
                        for (let i = 0; i < response.data.ROOT.SUB_DEPARTMENTS.length; i++) {
                            this.secondary_subdept.push(response.data.ROOT.SUB_DEPARTMENTS[i].PK);
                        }
                    }
                }
            })

        axios.get('./remote-apis/user-api.php?cmd=pro_sal')
            .then(res => {
                if (res.data.response) {
                    if (res.data.response == "Success") {
                        this.salary = res.data.salary ;
                    } else {
                        this.salary = "" ;
                    }
                } else {
                    this.error = res.data.message;
                }
            }) .catch(err => {
                window.console.error(err);
                this.error = 'Request failed';
            }) ;

        axios.get('./remote-apis/user-api.php?cmd=sl')
            .then(response => {
                this.suite_level = response.data.ROOT.SUITE_LEVELS
            })

        axios.get('./remote-apis/user-api.php?cmd=bldg')
            .then(response => {
                this.buildings = response.data.ROOT.BUILDINGS
            })
    },

    methods: {
        
        saveAllChanges: function() {
            const self = this
            //this.loader = 'loading'
            this.loading = true
            let formData = new FormData()
            let imageFile = this.headshot
            formData.append('primary_subdept', this.selected_primary_subdept)
            formData.append('room', this.room)
            formData.append('suite_level', this.selected_suite_level)
            formData.append('building', this.selected_building)
            formData.append('uploaded_file', imageFile)
            formData.append('professional_bio', this.professional_bio)
            formData.append('degrees_earned', this.selected_degrees)
            formData.append('certifications', this.selected_credentials)
            axios.post('./remote-apis/save-data.php', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(response => {
                    
                    window.console.log(response)
                    self.loading = false
                    self.data_saved = true
                    
                })
                .catch(error => {
                    return(
                    alert(error)
                    )
                })
            
        }
    }
}
</script>